import Vue from 'vue';
import Vuex from 'vuex';
import { sync } from 'vuex-router-sync';
import App from './App.vue';
import moment from 'moment';

import router from './router';
import store from './store';
import Buety from 'buefy';
import VueExcelXlsx from 'vue-excel-xlsx';
import 'buefy/dist/buefy.min.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleLeft,
  faAngleRight,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faCalendarDay,
  faCheck,
  faCheckCircle,
  faChevronUp,
  faExclamationTriangle,
  faTimesCircle,
  faTrashAlt,
  faPlus,
  faDownload,
  faMinus,
  faUndo,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import {
  faQuestionCircle,
  faWindowClose,
  faCaretDown,
  faCaretUp,
} from '@fortawesome/free-solid-svg-icons';
import BootstrapVue from 'bootstrap-vue';

Vue.use(BootstrapVue);
library.add(
  faAngleLeft,
  faAngleRight,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faCalendarDay,
  faCheck,
  faCheckCircle,
  faChevronUp,
  faExclamationTriangle,
  faTimesCircle,
  faTrashAlt,
  faPlus,
  faDownload,
  faSearch,
  faQuestionCircle,
  faWindowClose,
  faCaretDown,
  faCaretUp,
  faMinus,
  faUndo
);

Vue.component('fa', FontAwesomeIcon);

Vue.filter('formatDateString', function (val: string, formatString: string) {
  return val ? moment(val).format(formatString) : val;
});

Vue.filter('formatNumber', function (val: number) {
  return val ? val.toLocaleString() : val;
});

Vue.filter('formatCurrency', function (val: number, symbol: string) {
  return val ? symbol + val.toLocaleString() : val;
});

Vue.use(Buety, {
  defaultFieldLabelPosition: 'on-border',
  defaultIconComponent: 'fa',
  defaultIconPack: 'fa',
});
Vue.use(Vuex);
Vue.use(VueExcelXlsx);
Vue.config.productionTip = false;

router.beforeEach((to, _, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.state.user) {
      next();
    } else {
      next({ name: 'login', query: { redirect: to.path } });
    }
  } else {
    next();
  }
});

sync(store, router);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
